
const companyElement = document.querySelector<HTMLSelectElement>("#slUserCompany");
const isBravureCheckbox = document.querySelector<HTMLInputElement>('[name="Command.Roles"][value="Aryza"]');
const isBravureAdminCheckbox = document.querySelector<HTMLInputElement>('[name="Command.Roles"][value="Admin"]');
const accessPricingInformationCheckbox = document.querySelector<HTMLInputElement>('#ckAccessPricingInformation');

if (isBravureAdminCheckbox && isBravureCheckbox && companyElement) {
    // default
    isBravureAdminCheckbox.disabled = !isBravureCheckbox.checked;
    onCompanySelectChange(true);

    if (isBravureAdminCheckbox.disabled)
        isBravureAdminCheckbox.checked = false;

    // on bravure role check
    isBravureCheckbox.addEventListener("change", (e) => {
        // set bravure select
        if (isBravureCheckbox.checked) {
            for (var i = 0, n = companyElement.options.length; i < n; i++) { // looping over the options
                if (companyElement.options[i].text === "Aryza") {
                    companyElement.options[i].selected = true;
                    break;
                }
            }
            isBravureAdminCheckbox.disabled = false;
        } else {
            companyElement.selectedIndex = 0;
            isBravureAdminCheckbox.disabled = true;
            isBravureAdminCheckbox.checked = false;
        }
        companyElement.classList.remove("is-invalid");

        onCompanySelectChange();
    });

    // on company select change
    companyElement.addEventListener("change", (e) => {
        onCompanySelectChange();
    });
}

function onCompanySelectChange(init=false) {
    // get toggles
    const sellerElement = document.querySelector<HTMLInputElement>("#lblIsSeller");
    const buyerElement = document.querySelector<HTMLInputElement>("#lblIsBuyer");

    // show seller/buyer info
    const selectedOptionElement = companyElement.selectedOptions[0];

    if (selectedOptionElement.dataset["isSeller"] == "true") {
        sellerElement.classList.toggle("status-success", true)
    } else {
        sellerElement.classList.toggle("status-success", false)
    }

    if (selectedOptionElement.dataset["isBuyer"] == "true") {
        buyerElement.classList.toggle("status-success", true)
    } else {
        buyerElement.classList.toggle("status-success", false)
    }

    // toggle role

    if (selectedOptionElement.text === "Aryza") {
        isBravureCheckbox.checked = true;
    } else {
        isBravureCheckbox.checked = false;
    }

    isBravureAdminCheckbox.disabled = !isBravureCheckbox.checked;
    if (isBravureAdminCheckbox.disabled)
        isBravureAdminCheckbox.checked = false;

    // toggle Access Pricing Information
    if (!init && accessPricingInformationCheckbox && isBravureCheckbox.checked) {
        accessPricingInformationCheckbox.checked = true;
    }
}
export default undefined;